import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { SharedService } from 'app/modules/common/services/shared-service';
import { TaskTransferTypes } from 'app/modules/common/enums/task-transfer-types';
import { SelectionGenericService } from 'app/modules/selection-generic/services/selection-generic.service';
import { UntypedFormControl } from '@angular/forms';
import { DateHelper } from 'app/modules/common/helpers/DateHelper';

@Component({
    selector: 'app-task-trasfer-popup',
    templateUrl: './task-trasfer-popup.component.html',
    styleUrls: ['./task-trasfer-popup.component.scss'],
    standalone: false
})
export class TaskTrasferPopupComponent implements OnInit {

  public popupTitle = '';
  public TaskTransferTypes = TaskTransferTypes;
  public TransferType: TaskTransferTypes;

  constructor(
    public dialogRef: MatDialogRef<TaskTrasferPopupComponent>,
    public sharedService: SharedService,
    public selectionService: SelectionGenericService
  ) { }

  ngOnInit(): void {
    this.setPopupTitle();
  }

  setPopupTitle(): void {
    switch (this.TransferType) {
      case TaskTransferTypes.Doctor:
        this.popupTitle = 'Derivar todas las tareas al medico';
        
        break;

      case TaskTransferTypes.Administrator:
        this.popupTitle = 'Derivar todas las tareas al/la gestionador/a';
        break;

      case TaskTransferTypes.Date:
        this.popupTitle = 'Cambiar fecha de las tareas';
        break;
    
      default:
        break;
    }

    this.selectionService.TaskTransferInput = new UntypedFormControl(null);
  }

  closePopup(): void {
    this.dialogRef.close();
  }

  transferTasks(): void {
    this.dialogRef.close();
    if (this.selectionService.TaskTransferInput.valid) {
      let value = this.selectionService.TaskTransferInput.value;
      this.selectionService.isTaskTranserLoading = true;
      if (this.TransferType === TaskTransferTypes.Date) {
        value = DateHelper.getUTCDateString(this.selectionService.TaskTransferInput.value._d);
      }
      this.selectionService.transferTasks(this.TransferType, value).subscribe(res => {
        
        if (res.code === 0) {
          this.sharedService.ShowSnackBar('La transferencia de tareas fue exitosa', 'okay', 2000);
        } else {
          this.sharedService.ShowSnackBar('No se pudieron transferir las tareas, inténtelo de nuevo', 'okay', 2000);
        }
        this.selectionService.isTaskTranserLoading = false;
        this.selectionService.SearchTasks(0, 50, true);
      }, error => {
        this.selectionService.isTaskTranserLoading = false;
        this.sharedService.ShowSnackBar('Hubo un error al transferir las tareas', 'okay', 2000);
        console.error(error);
      });
    } else {
      this.sharedService.ShowSnackBar('Por favor ingrese una entrada válida', 'okay', 2000);
    }
  }

}
